module.exports = __webpack_public_path__ + "img/clothing156.f7e9cdf8.jpg";